import { render } from "./App.vue?vue&type=template&id=08813796"
const script = {}

import "./App.vue?vue&type=style&index=0&id=08813796&lang=css"
script.render = render

export default script